import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/passport-stamp-video-poster.jpg")